<div class="d-flex flex-wrap my-2 align-items-start gap-1">
  @for (item of items(); track item) {
    <span class="badge bg-secondary">
      {{ item }}
    </span>
  }
</div>
